import { coreStakeholdersDeleteAsyncSlice } from './delete';
import { coreStakeholdersGetAsyncSlice } from './get';
import { coreStakeholdersIdMapReducers } from './_idMap';
import { coreStakeholdersPatchAsyncSlice } from './patch';
import { coreStakeholdersPostAsyncSlice } from './post';
import { coreStakeholdersRemoveSyncSlice } from './remove';
import { Stakeholder } from '@types';

import { AsyncState, combineAllWatchers, joinReducers } from '@sonar-software/xuder';
import { combineReducers, Reducer } from 'redux';

export const coreStakeholdersReducers = combineReducers({
	byIdMap: coreStakeholdersIdMapReducers,
	delete: coreStakeholdersDeleteAsyncSlice.asyncReducers,
	get: joinReducers(
		[ coreStakeholdersGetAsyncSlice.asyncReducers, coreStakeholdersRemoveSyncSlice.syncReducer ],
		coreStakeholdersGetAsyncSlice.asyncState
	) as Reducer<AsyncState<Array<Stakeholder>>>,
	patch: coreStakeholdersPatchAsyncSlice.asyncReducers,
	post: coreStakeholdersPostAsyncSlice.asyncReducers
});

export const coreStakeholdersWatchers = combineAllWatchers([
	coreStakeholdersDeleteAsyncSlice.asyncWatchers,
	coreStakeholdersGetAsyncSlice.asyncWatchers,
	coreStakeholdersPatchAsyncSlice.asyncWatchers,
	coreStakeholdersPostAsyncSlice.asyncWatchers
]);
